// DO NOT EDIT!!! This file is auto-generated.
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var MESSAGES_BY_LOCALE = {
    en: {
        accept_cookies: 'Accept',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Accept All',
        banner_allow_all: 'Allow All',
        banner_consent_to_cookies: 'Consent to Cookies',
        banner_content: 'We use cookies on our site to enhance your experience, improve our site, and to deliver content and ads that are relevant to you. You can choose to accept all cookies by clicking {accept_link}, or you can manage them individually by clicking {managecookies_link}, where you can read more. ',
        banner_deny_all: 'Deny All',
        consent_manager_preferences_close: 'Close',
        cookie_category_advertising: 'Advertising',
        cookie_category_functional: 'Functional',
        cookie_category_marketing: 'Marketing and Analytics',
        cookie_description_advertising: 'To personalize and measure the effectiveness of advertising on our site and other websites.',
        cookie_description_functional: 'To monitor the performance of our site and to enhance your browsing experience.',
        cookie_description_marketing: 'To understand user behavior in order to provide you with a more relevant browsing experience or personalize the content on our site.',
        cookie_example_advertising: 'For example, we may serve you a personalized ad based on the pages you visit on our site.',
        cookie_example_functional: 'For example, these tools enable you to communicate with us via live chat.',
        cookie_example_marketing: 'For example, we collect information about which pages you visit to help us present more relevant information.',
        cookie_title: 'We value your privacy.',
        default_cookie_allow: 'Allow',
        default_cookie_category: 'Category',
        default_cookie_purpose: 'Purpose',
        default_cookie_tools: 'Tools',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Manage cookies',
        no: 'No',
        save: 'Save',
        yes: 'Yes',
    },
    ja: {
        accept_cookies: '同意する',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'すべて同意する',
        banner_allow_all: 'すべて許可',
        banner_consent_to_cookies: 'Cookieの使用に関する同意',
        banner_content: '当サイトでは、エクスペリエンスの向上、サイトの利便性の向上、お客様が関心のあるコンテンツや広告の配信を目的として、Cookieを使用しています。{accept_link}をクリックしてすべてのCookieを受け入れるか、{managecookies_link}をクリックして、詳細にCookieを管理するかを選択してください。',
        banner_deny_all: 'すべてブロック',
        consent_manager_preferences_close: '閉じる',
        cookie_category_advertising: '広告',
        cookie_category_functional: '機能',
        cookie_category_marketing: 'マーケティングと分析',
        cookie_description_advertising: '当社サイトおよび他のウェブサイトにおける広告のパーソナライズおよび効果を測定するため。',
        cookie_description_functional: '当社のサイトのパフォーマンスをモニタリングし、お客様の閲覧エクスペリエンスを向上させるため。',
        cookie_description_marketing: 'より関連性の高いコンテンツを提供、または当サイトのコンテンツをパーソナライズすることを目的として、ユーザーの行動を理解するため。',
        cookie_example_advertising: '例えば、お客様が当サイトでの閲覧ページ履歴に基づいて、パーソナライズされた広告を配信する場合があります。',
        cookie_example_functional: '例えば、これらのツールにより、お客様がライブチャットを通じて当社と連絡することを可能にします。',
        cookie_example_marketing: '例えば、より適切な情報を提供することを目的として、お客様がどのページを閲覧したかについての情報を収集します。',
        cookie_title: 'お客様のプライバシー保護について',
        default_cookie_allow: '許可',
        default_cookie_category: 'カテゴリー',
        default_cookie_purpose: '目的',
        default_cookie_tools: 'ツール',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Cookieの管理',
        no: 'いいえ',
        save: '保存',
        yes: 'はい',
    },
    de: {
        accept_cookies: 'Akzeptieren',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Alle akzeptieren',
        banner_allow_all: 'Alle erlauben',
        banner_consent_to_cookies: 'Zustimmung zu Cookies',
        banner_content: 'Wir verwenden auf unserer Website Cookies, um deine Nutzererfahrung zu verbessern, unsere Website zu optimieren und dir relevante Inhalte und Werbung anzuzeigen. Du kannst alle Cookies akzeptieren, indem du auf {accept_link} klickst, oder sie einzeln verwalten, indem du auf {managecookies_link} klickst, wo du mehr darüber erfährst.',
        banner_deny_all: 'Alle ablehnen',
        consent_manager_preferences_close: 'Schließen',
        cookie_category_advertising: 'Werbung',
        cookie_category_functional: 'Funktionelle',
        cookie_category_marketing: 'Marketing und Analysen',
        cookie_description_advertising: 'Zur Personalisierung und Messung der Wirksamkeit von Werbung auf unserer Website und anderen Websites.',
        cookie_description_functional: 'Um die Leistung unserer Website zu überwachen und dein Nutzererlebnis zu verbessern.',
        cookie_description_marketing: 'Um das Nutzerverhalten zu verstehen und dir relevantere Inhalte zu präsentieren oder die Inhalte auf unserer Website zu personalisieren.',
        cookie_example_advertising: 'Wir können dir zum Beispiel personalisierte Werbung anzeigen, die auf den Seiten basiert, die du auf unserer Website besuchst.',
        cookie_example_functional: 'Diese Tools ermöglichen es dir zum Beispiel, mit uns über den Live-Chat zu kommunizieren.',
        cookie_example_marketing: 'Wir sammeln zum Beispiel Informationen darüber, welche Seiten du besuchst, damit wir dir relevante Informationen anzeigen können.',
        cookie_title: 'Wir respektieren deine Privatsphäre.',
        default_cookie_allow: 'Erlauben',
        default_cookie_category: 'Kategorie',
        default_cookie_purpose: 'Zweck',
        default_cookie_tools: 'Tools',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Cookies verwalten',
        no: 'Nein',
        save: 'Speichern',
        yes: 'Ja',
    },
    fr: {
        accept_cookies: 'Accepter',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Tout accepter',
        banner_allow_all: 'Tout autoriser',
        banner_consent_to_cookies: 'Autorisation des cookies',
        banner_content: "Nous utilisons des cookies sur notre site afin d'améliorer votre expérience et notre site, et de vous proposer des annonces et des contenus adaptés. Vous pouvez choisir d'accepter tous les cookies en cliquant sur {accept_link}, ou de les gérer individuellement en cliquant sur {managecookies_link}, où vous pouvez en savoir plus.",
        banner_deny_all: 'Tout refuser',
        consent_manager_preferences_close: 'Fermer',
        cookie_category_advertising: 'Publicité',
        cookie_category_functional: 'Fonctionnels',
        cookie_category_marketing: 'Marketing et données analytiques',
        cookie_description_advertising: "Pour personnaliser la publicité sur notre site et d'autres sites Web, et en mesurer l'efficacité.",
        cookie_description_functional: 'Pour surveiller les performances de notre site et améliorer votre expérience de navigation.',
        cookie_description_marketing: 'Pour comprendre le comportement des utilisateurs et des utilisatrices afin de vous offrir une expérience de navigation plus pertinente ou de personnaliser le contenu de notre site.',
        cookie_example_advertising: 'Par exemple, nous pouvons vous proposer une annonce personnalisée en fonction des pages que vous visitez sur notre site.',
        cookie_example_functional: 'Par exemple, ces outils vous permettent de communiquer avec nous via un chat en direct.',
        cookie_example_marketing: 'Par exemple, nous collectons des informations sur les pages que vous visitez pour nous aider à vous présenter des informations plus pertinentes.',
        cookie_title: 'Nous respectons votre vie privée.',
        default_cookie_allow: 'Autoriser',
        default_cookie_category: 'Catégorie',
        default_cookie_purpose: 'Finalité',
        default_cookie_tools: 'Outils',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Gérer les cookies',
        no: 'Non',
        save: 'Enregistrer',
        yes: 'Oui',
    },
    it: {
        accept_cookies: 'Accetta',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Accetta tutti',
        banner_allow_all: 'Consenti tutti',
        banner_consent_to_cookies: 'Accetta i cookie',
        banner_content: 'Utilizziamo i cookie sul nostro sito per migliorare la tua esperienza, migliorare il nostro sito e fornire contenuti e annunci pertinenti per te. Puoi scegliere di accettare tutti i cookie facendo clic su {accept_link}, oppure puoi gestirli singolarmente facendo clic su {managecookies_link}, dove potrai anche ottenere ulteriori informazioni. ',
        banner_deny_all: 'Rifiuta tutti',
        consent_manager_preferences_close: 'Chiudi',
        cookie_category_advertising: 'Pubblicità',
        cookie_category_functional: 'Funzionali',
        cookie_category_marketing: 'Marketing e analisi',
        cookie_description_advertising: "Per personalizzare e misurare l'efficacia della pubblicità sul nostro sito e su altri siti web.",
        cookie_description_functional: 'Per monitorare le prestazioni del nostro sito e per migliorare la tua esperienza di navigazione.',
        cookie_description_marketing: "Per capire il comportamento degli utenti al fine di fornire un'esperienza di navigazione più pertinente o personalizzare il contenuto del nostro sito.",
        cookie_example_advertising: 'Così, ad esempio, possiamo proporti annunci personalizzati in base alle pagine che visiti sul nostro sito.',
        cookie_example_functional: 'Ad esempio, questi strumenti ti consentono di comunicare con noi tramite live chat.',
        cookie_example_marketing: 'Ad esempio, raccogliamo informazioni sulle pagine che visiti per aiutarci a fornirti informazioni più pertinenti.',
        cookie_title: 'La tua privacy è importante per noi.',
        default_cookie_allow: 'Consenti',
        default_cookie_category: 'Categoria',
        default_cookie_purpose: 'Scopo',
        default_cookie_tools: 'Strumenti',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Gestisci i cookie',
        no: 'No',
        save: 'Salva',
        yes: 'Sì',
    },
    fi: {
        accept_cookies: 'Hyväksy kaikki',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Hyväksy kaikki',
        banner_allow_all: 'Salli kaikki',
        banner_consent_to_cookies: 'Suostumus evästeiden käyttöön',
        banner_content: 'Käytämme sivustollamme evästeitä parantaaksemme käyttökokemustasi, parantaaksemme sivustoamme ja tarjotaksemme sinulle merkityksellistä sisältöä ja mainoksia. Voit hyväksyä kaikki evästeet napsauttamalla {accept_link}, tai voit hallita niitä erikseen napsauttamalla {managecookies_link}, jolloin saat myös lisätietoa käytetyistä evästeistä.',
        banner_deny_all: 'Kiellä kaikki',
        consent_manager_preferences_close: 'Sulje',
        cookie_category_advertising: 'Mainonta',
        cookie_category_functional: 'Toiminnallisuus',
        cookie_category_marketing: 'Markkinointi ja analytiikka',
        cookie_description_advertising: 'Näiden evästeiden tarkoituksena on personoida sivustollamme ja muilla verkkosivuilla näkemiäsi mainoksia ja mitata niiden tehokkuutta.',
        cookie_description_functional: 'Näiden evästeiden tarkoituksena on seurata sivustomme toimivuutta ja parantaa käyttäjäkokemustasi sivustollamme.',
        cookie_description_marketing: 'Näiden evästeiden tarkoituksena on ymmärtää käyttäjien toimintaa, jotta voisimme tarjota mahdollisimman hyödyllisen käyttäjäkokemuksen sivustollamme tai personoida sivustomme sisältöä.',
        cookie_example_advertising: 'Voimme esimerkiksi näyttää sinulle personoidun mainoksen sen perusteella, millä sivustomme sivuilla olet käynyt.',
        cookie_example_functional: 'Näiden työkalujen ansiosta voit esimerkiksi keskustella kanssamme chatissa reaaliaikaisesti.',
        cookie_example_marketing: 'Keräämme tietoa esimerkiksi siitä, millä sivuilla käyt, jotta voimme tarjota mahdollisimman hyödyllistä tietoa.',
        cookie_title: 'Arvostamme yksityisyyttäsi.',
        default_cookie_allow: 'Salli',
        default_cookie_category: 'Kategoria',
        default_cookie_purpose: 'Tarkoitus',
        default_cookie_tools: 'Työkalut',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Hallinnoi evästeitä',
        no: 'Ei',
        save: 'Tallenna',
        yes: 'Kyllä',
    },
    es: {
        accept_cookies: 'Aceptar',
        allow_tracking_for_category: 'Allow {category} tracking',
        banner_accept_all: 'Aceptarlas todas',
        banner_allow_all: 'Permitirlas todas',
        banner_consent_to_cookies: 'Consentimiento para el uso de cookies',
        banner_content: 'En nuestro sitio web utilizamos cookies para mejorar tu experiencia, mejorar nuestro sitio y ofrecerte contenidos y anuncios que sean de tu interés. Puedes hacer clic en {accept_link} para aceptar todas las cookies o bien hacer clic en {managecookies_link} para gestionarlas de forma individualizada y obtener más información al respecto.',
        banner_deny_all: 'Rechazarlas todas',
        consent_manager_preferences_close: 'Cerrar',
        cookie_category_advertising: 'Publicidad',
        cookie_category_functional: 'Funcional',
        cookie_category_marketing: 'Marketing y analítica',
        cookie_description_advertising: 'Para personalizar y medir la efectividad de la publicidad en nuestro sitio web y otros sitios web.',
        cookie_description_functional: 'Para monitorizar el rendimiento de nuestro sitio web y mejorar la experiencia de sus visitantes.',
        cookie_description_marketing: 'Para entender el comportamiento de los usuarios y mejorar su experiencia o personalizar el contenido en nuestro sitio web.',
        cookie_example_advertising: 'Por ejemplo, podemos mostrarte un anuncio personalizado en base a las páginas que visites en nuestro sitio web.',
        cookie_example_functional: 'Por ejemplo, estas herramientas te permiten comunicarte con nosotros en tiempo real a través del chat.',
        cookie_example_marketing: 'Por ejemplo, recogemos datos sobre las páginas que visitas para poder ofrecerte información más relevante.',
        cookie_title: 'Respetamos tu privacidad.',
        default_cookie_allow: 'Permitir',
        default_cookie_category: 'Categoría',
        default_cookie_purpose: 'Propósito',
        default_cookie_tools: 'Herramientas',
        disallow_tracking_for_category: 'Disallow {category} tracking',
        manage_cookies: 'Gestionar las cookies',
        no: 'No',
        save: 'Guardar',
        yes: 'Sí',
    },
};
export var LOCALES_SUPPORTED = [
    'en',
    'ja',
    'de',
    'fr',
    'it',
    'fi',
    'es',
];
export var LOCALE_DEFAULT = 'en';
export var MESSAGE_KEYS = [
    'accept_cookies',
    'allow_tracking_for_category',
    'banner_accept_all',
    'banner_allow_all',
    'banner_consent_to_cookies',
    'banner_content',
    'banner_deny_all',
    'consent_manager_preferences_close',
    'cookie_category_advertising',
    'cookie_category_functional',
    'cookie_category_marketing',
    'cookie_description_advertising',
    'cookie_description_functional',
    'cookie_description_marketing',
    'cookie_example_advertising',
    'cookie_example_functional',
    'cookie_example_marketing',
    'cookie_title',
    'default_cookie_allow',
    'default_cookie_category',
    'default_cookie_purpose',
    'default_cookie_tools',
    'disallow_tracking_for_category',
    'manage_cookies',
    'no',
    'save',
    'yes',
];
export var isMessageKey = function (key) {
    return __spreadArray([], MESSAGE_KEYS, true).indexOf(key) !== -1;
};
